import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import DeleteTextButton from '../../components/atoms/DeleteTextButton';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  scrollTable: {
    maxHeight: '70vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  textMessage: {
    whiteSpace: 'break-spaces'
  },
  system: {
    width: 400,
    whiteSpace: 'break-spaces',
    wordBreak: 'keep-all'
  },
  title: {
    width: 400,
    whiteSpace: 'break-spaces',
    wordBreak: 'keep-all'
  },
  headerTable: {
    fontWeight: 700
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      listMessageSentByAdmin:
        state.users.listMessageSentByAdmin &&
        state.users.listMessageSentByAdmin.data
          ? state.users.listMessageSentByAdmin.data.list
          : [],
      totalCount:
        state.users.listMessageSentByAdmin &&
        state.users.listMessageSentByAdmin.data
          ? state.users.listMessageSentByAdmin.data.count
          : 0
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    listMessageSentByAdmin,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    setRowsPerPage,
    openConfirmDelete
  }) => {
    return (
      <div className={classes.root}>
        <div className={classes.scrollTable}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerTable}>ID</TableCell>
                <TableCell className={classes.headerTable}>配信日</TableCell>
                <TableCell className={classes.headerTable}>配信先</TableCell>
                <TableCell className={classes.headerTable}>件名</TableCell>
                <TableCell className={classes.headerTable}>内容</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {listMessageSentByAdmin &&
                listMessageSentByAdmin.map(message => (
                  <TableRow key={message.shashokuMessageByAdminId}>
                    <TableCell>{message.shashokuMessageByAdminId}</TableCell>
                    <TableCell>{message.sendAt}</TableCell>
                    <TableCell>
                      <div className={classes.system}>
                        {message.allSystem === 1
                          ? '社食ごちめしの全ての法人'
                          : message.connectSystemDtos
                              .map(system => system.connectSystemName)
                              .join(', ')}
                      </div>
                    </TableCell>
                    <TableCell className={classes.title}>
                      {message.title}
                    </TableCell>
                    <TableCell className={classes.textMessage}>
                      {message.message}
                    </TableCell>
                    <TableCell>
                      <DeleteTextButton
                        onClickAction={() =>
                          openConfirmDelete(
                            message.shashokuMessageByAdminId,
                            message.title
                          )
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <ExPaginationGroup
          count={
            totalCount % rowsPerPage > 0
              ? Math.floor(totalCount / rowsPerPage) + 1
              : Math.floor(totalCount / rowsPerPage)
          }
          selectedPage={page}
          handleChangePage={(e, p, limit) => handleChangePage(e, p, limit)}
          limit={rowsPerPage}
          totalCount={totalCount}
          setLimit={setRowsPerPage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
